import React, { useState } from "react";
import "./addPhoto.scss";
import TextInput from "../textInput/TextInput";
import PhotoCheck from "./photoCheck/PhotoCheck";
import trueIcon from "../../images/frames/green-check-icon.svg";
import falseIcon from "../../images/frames/red-check-icon.svg";
import YellowButton from "../buttons/defaultButton/yellowButton/YellowButton";
import { useEffect } from "react";

const AddPhoto = ({ lable, onClick, imgData, imgId, changeImgStatus, changeImgSubtitle }) => {
    const [photoUrl, setPhotoUrl] = useState("");

    useEffect(() => {
        if (imgData?.url) {
            setPhotoUrl(imgData.url);
        }
    }, [imgData?.url]);

    return (
        <div className="add-photo">
            <div className="input-lable">{lable}</div>
            <TextInput inputValue={photoUrl} setInputValue={setPhotoUrl} />
            <div className="add-photo__subtitle">
                <div className="input-lable">Підпис до фото</div>
                <TextInput
                    inputValue={imgData?.subtitle ? imgData?.subtitle : ""}
                    setInputValue={(value) => changeImgSubtitle(imgId, value)}
                />
            </div>
            <div className="add-photo__select">
                {imgData?.url && (
                    <>
                        {" "}
                        <div className="add-photo__select-photo-wrapper">
                            <img src={imgData.url} alt="price" className="add-photo__select-photo" />
                            <div className="add-photo__select-icon">
                                {imgData?.status ? (
                                    <img src={trueIcon} alt="true" className="add-photo__select-icon-img" />
                                ) : (
                                    <img src={falseIcon} alt="true" className="add-photo__select-icon-img" />
                                )}
                            </div>
                        </div>
                        <div className="add-photo__select-arrows">
                            <PhotoCheck
                                isChecked={imgData?.status}
                                setIsChecked={() => changeImgStatus(imgId, !imgData?.status)}
                            />
                        </div>{" "}
                    </>
                )}
            </div>
            <div className="add-photo__button">
                <YellowButton text={"Додати фото зліва +"} padding={"12px 24px"} font={"14px"} onClick={onClick} />
            </div>
        </div>
    );
};

export default AddPhoto;
